<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsElementCategorySlider']
}>()

const items = computed(() => Object.values(props.content?.data ?? {}))

const promotion = computed(() => props.content?.config?.promotion?.value ?? null)
</script>

<template>
    <SliderBase
        v-if="items.length > 0"
        :slides-per-view="{
            xs: 1,
            sm: content?.config?.slidesPerViewMobile?.value,
            md: content?.config?.slidesPerViewTablet?.value,
            lg: content?.config?.slidesPerViewDesktop?.value,
            xl: content?.config?.slidesPerViewDesktop?.value,
            '2xl': content?.config?.slidesPerViewDesktop?.value,
        }"
        :slide-count="items.length"
        :mobile-grid="false"
        :display-nav="true"
        :space-between="24"
        :progress-config="content?.config?.progressBar?.value ? 'progress_bar' : 'disabled'"
    >
        <template #default="{ index }">
            <div v-if="items[index] != null" class="category-swiper-slide w-full">
                <SliderSlideContentCategory
                    :config="items[index]!"
                    :index="index"
                    :promotion="promotion"
                />
            </div>
        </template>
    </SliderBase>
</template>